import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

export default function Logs() {
  const { t } = useTranslation();
  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 2 }}>
        {t('systemLogs.title')}
      </Typography>
      <Typography color="text.secondary">{t('systemLogs.placeholder')}</Typography>
    </Box>
  );
}
